module.exports = __webpack_public_path__ + "static/media/schneefall.6b33dd54.svg";